import Vue from 'vue'
import Router from 'vue-router'
// import Container from './views/Container.vue'

Vue.use(Router)

export default new Router({
    // mode: process.env.NODE_ENV !== 'production' ? 'history' : 'hash',
    mode: 'history',
    base: '/',
    routes: [{
            path: '/',
            name: 'start',
            component: () => import('./components/Article.vue')
        },
        // {
        //   path: '/',
        //   name: 'container',
        //   component:  () => import('./views/Plain.vue')
        // },
        {
            path: '/formular/:form',
            name: 'formular',
            component: () => import('./components/Formular.vue')
        },
        {
            path: '/search/:key',
            name: 'search',
            component: () => import('./components/Search.vue')
        },
        {
            path: '/journeycart',
            alias: '/journeycart/:kategorie',
            name: 'journeycart',
            component: () => import('./components/JourneyCart.vue')
        },
        {
            path: '/journeyoverview',
            alias: '/journeyoverview/:journeyoverview',
            name: 'journeyoverview',
            component: () => import('./components/JourneyOverview.vue')
        },
        {
            path: '/article',
            alias: '/article/:id',
            name: 'article',
            component: () => import('./components/Article.vue')
        },
        {
            path: '/journeydetail',
            alias: '/journeydetail/:id',
            name: 'journeydetail',
            component: () => import('./components/JourneyDetail.vue')
        },
        {
            path: '/plain',
            name: 'plain',
            component: () => import('./views/Plain.vue')
        }
    ]
})